import {Component, Input, OnInit} from '@angular/core';
import {SupportContact} from '@models/adminstration/organization/support-contact/support-contact';

@Component({
    selector: 'scitis-support-contact-item',
    templateUrl: './support-contact-item.component.html',
    styleUrls: ['./support-contact-item.component.scss'],
    standalone: false
})
export class SupportContactItemComponent implements OnInit {

  @Input()
  contact: SupportContact = new SupportContact();

  private defaultImage: string = './assets/img/fallback_avatar.png';

  constructor() {
  }

  ngOnInit(): void {
    if (!this.contact.image || this.contact.image.length === 0) {
      this.contact.image = this.defaultImage;
    }
  }

}
